import axios from "axios";
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import { baseUrl, baseimgUrl, userLocation } from '../Univ.js';

function InvFilesView() {
  const { id } = useParams();
  const [invData, setInvData] = useState([]);
  const [docs, setDocs] = useState([]);
  const [hospData, setHospData] = useState([]);

  // Fetch invoice images and data
  useEffect(() => {
    axios.get(`${baseUrl}inv-imgs-view/${id}/`)
      .then(response => setInvData([response.data]))
      .catch(error => console.log("API Error:", error));
  }, [id]);

  // Fetch hospital data
  useEffect(() => {
    axios.get(`${baseUrl}view-hospital/${userLocation}/`)
      .then(response => setHospData(response.data))
      .catch(error => console.log(error));
  }, []);

  // Prepare document URLs
  useEffect(() => {
    if (invData.length > 0) {
      const base = `${baseimgUrl}media/`;
      const urlsArray = invData[0].invt_files.split(',');
      const documents = urlsArray.map(url => ({
  uri: `${baseimgUrl}media/${url.trim()}`
}));
      setDocs(documents);
    }
  }, [invData]);

  // Print function
  const handlePrint = () => {
    const printContents = document.getElementById('invoice-print').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    setTimeout(() => window.location.reload(), 1000);
    document.body.innerHTML = originalContents;
  };

  return (
    <section>
      <div id="invoice-print">
        {/* Hospital Header */}
        <table rules="rows" cellPadding="3" className="text-justify mt-5" width="100%">
          <thead>
            <tr>
              {hospData.map((hospital, idx) => (
                <td key={idx} align="center" colSpan="2">
                   {hospital.logo && (
  <img
    src={hospital.logo}
    alt="Hospital Logo"
    style={{ height: "80px", marginBottom: "10px" }}
  />
)}<strong>{hospital.hospital}</strong><br />
                  Address: {hospital.address} <br />
                  Phone: {hospital.mobile} &nbsp; Email: {hospital.email} <br />
                  Web: {hospital.website}
                </td>
              ))}
            </tr>
          </thead>
        </table>

        {/* Patient & Invoice Data */}
        {invData.map((row, index) => (
          <div key={index} style={{ marginTop: '20px' }}>
            {/* Patient Info Table */}
            <div className="table-responsive">
              <table className="erp-table-modern">
                <thead>
                  <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
                    <th>Patient ID</th>
                    <th>Patient Name</th>
                    <th>Gender</th>
                    <th>D.O.B/Age</th>
                    <th>Mobile</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{row.pat.pat_id}</td>
                    <td>{row.pat.patient}</td>
                    <td>{row.pat.gender}</td>
                    <td>{row.pat.age}</td>
                    <td>{row.pat.mobile}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Test Name */}
            <div style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '15px' }}>
              {row.appt.inv_test.split(',')[index]}
            </div>

            {/* Images & Remarks Side by Side */}
            <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>

              {/* Left Pane - Images */}
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {docs.map((doc, i) => (
                  <div
                    key={i}
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      padding: '5px',
                      textAlign: 'center',
                    }}
                  >
  <img
  src={`${baseimgUrl}/media/${doc.uri.split('media/').pop()}`}
  alt={`Document ${i + 1}`}
  style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
/>
                  <p style={{ fontSize: '12px', wordBreak: 'break-all' }}>{doc.uri}</p>
                  </div>
                ))}
              </div>

              {/* Right Pane - Remarks */}
              <div style={{ flex: 1, border: '1px solid #ccc', borderRadius: '5px', padding: '10px' }}>
                <h4>Remarks</h4>
                <div>{parse(row.remarks)}</div>
              </div>

            </div>
          </div>
        ))}

        {/* Print Button */}
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button onClick={handlePrint} className="btn btn-primary">Print</button>
        </div>
      </div>
    </section>
  );
}

export default InvFilesView;
